import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import 'swiper/css/free-mode';

window.EquipmentShowcase = (showcaseId, totalCategories) => {
    return {
        active: 0,
        swiper: null,
        atStart: true,
        atEnd: false,

        init() {
            setTimeout(() => {
                this.swiper = new Swiper('.' + showcaseId + '-tabs', {
                    modules: [FreeMode],
                    slidesPerView: 'auto',
                    spaceBetween: 4,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                    grabCursor: true,
                    touchEventsTarget: 'container',
                    observer: true,
                    observeParents: true,
                    a11y: true,
                });

                this.swiper.update();
                this.updateEdgeState();

                this.swiper.on('progress', () => {
                    this.updateEdgeState();
                });

                this.swiper.on('reachBeginning', () => {
                    this.atStart = true;
                });

                this.swiper.on('reachEnd', () => {
                    this.atEnd = true;
                });
            }, 0);
        },

        updateEdgeState() {
            if (!this.swiper) return;
            this.atStart = this.swiper.isBeginning;
            this.atEnd = this.swiper.isEnd;
        },

        setActive(index) {
            this.active = index;
        },

        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },

        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
    };
};
